import { useState } from 'react';

export default function ReflectionInput({ initialNote, onSave, prompt, titulo, embedded = false, lockAfterSave = false }) {
  const [note, setNote] = useState(initialNote || '');
  const [saved, setSaved] = useState(!!initialNote);
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    if (!note.trim()) return;
    setLoading(true);
    const { error } = await onSave(note);
    setLoading(false);
    if (!error) setSaved(true);
  };

  const isLocked = lockAfterSave && (saved || !!initialNote);

  if (isLocked) {
    return (
      <div className={`reflection-area${embedded ? '' : ' card'}`}>
        {titulo && <h3>{titulo}</h3>}
        {prompt && <p className="reflection-prompt">{prompt}</p>}
        <p style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: 15,
          color: 'var(--navy)',
          lineHeight: 1.7,
          padding: '12px 0',
          whiteSpace: 'pre-wrap',
        }}>
          {note}
        </p>
        <span className="msg msg-success">🌟 Reflexão salva!</span>
      </div>
    );
  }

  return (
    <div className={`reflection-area${embedded ? '' : ' card'}`}>
      {titulo && <h3>{titulo}</h3>}
      {prompt && <p className="reflection-prompt">{prompt}</p>}
      <textarea
        className="input"
        value={note}
        onChange={e => { setNote(e.target.value); setSaved(false); }}
        placeholder="Escreva aqui sua reflexão..."
        rows={4}
        style={{ fontSize: '16px' }}
      />
      <div className="reflection-actions">
        {saved && <span className="msg msg-success">🌟 Reflexão salva!</span>}
        <button
          className="btn btn-primary btn-sm"
          onClick={handleSave}
          disabled={loading || !note.trim() || saved}
        >
          {loading ? 'Salvando...' : 'Salvar reflexão'}
        </button>
      </div>
    </div>
  );
}
